// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"b2b1e83d","13":"e7e50aaf","96":"2526f0a9","140":"b2b1e83d","775":"b2b1e83d","962":"1b7f992f"}[chunkId] + ".chunk.css";
};